module.exports = __webpack_public_path__ + "static/media/react-bootstrap-carousel.21823303.eot";